import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

/**
 * Show all review images in a swiper:
 * - Big screens: 3 per view
 * - Small screens: 1 per view
 * - Autoplay enabled
 */

const images = [
  { id: 1, src: "/review/review1.jpeg" },
  { id: 2, src: "/review/review2.jpeg" },
  { id: 3, src: "/review/review3.jpeg" },
  { id: 4, src: "/review/review4.jpeg" },
  { id: 5, src: "/review/review5.jpeg" },
  // omit 6th image
  { id: 7, src: "/review/review7.jpeg" },
  { id: 8, src: "/review/review8.jpeg" },
  { id: 9, src: "/review/review9.jpeg" },
  { id: 10, src: "/review/review10.jpeg" },
  { id: 11, src: "/review/review11.jpeg" },
  { id: 12, src: "/review/review12.jpeg" },
  { id: 13, src: "/review/review13.jpeg" },
  { id: 14, src: "/review/review14.jpeg" },
  { id: 15, src: "/review/review15.jpeg" },
  { id: 16, src: "/review/review16.jpeg" },
  { id: 17, src: "/review/review17.jpeg" },
  { id: 18, src: "/review/review18.jpeg" },
  { id: 19, src: "/review/review19.jpeg" },
  { id: 20, src: "/review/review20.jpeg" },
  { id: 21, src: "/review/review21.jpeg" },
  { id: 22, src: "/review/review22.jpeg" },
  { id: 23, src: "/review/review23.jpeg" },
  { id: 24, src: "/review/review24.jpeg" },
  { id: 25, src: "/review/review25.jpeg" },
  { id: 26, src: "/review/review26.jpeg" },
  { id: 27, src: "/review/review27.jpeg" },
  { id: 28, src: "/review/review28.jpeg" },
  { id: 29, src: "/review/review29.jpeg" },
];

export default function GalleryGrid() {
  return (
    <section className="w-full px-4 md:px-10 py-16">
      <Swiper
        spaceBetween={24}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 3 }
        }}
        className="w-full"
        modules={[Autoplay]}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false
        }}
        loop={true}
      >
        {images.map((img) => (
          <SwiperSlide key={img.id}>
            <div className="relative overflow-hidden  h-[320px] flex items-center justify-center">
              <img
                src={img.src}
                alt={`review${img.id}`}
                className="object-contain w-full h-full transition-transform duration-700 ease-out hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
